module.exports = __webpack_public_path__ + "static/img/produto_p.1a6acbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/limao-zero/produto_p.png
// module id = 2HGn
// module chunks = 0